import { useState } from 'react'
import { Link, useSearchParams } from 'react-router'
import { auth } from '@/api/endpoints'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Err } from '@/components/Err'
import { AuthCard } from './Card'

// 비밀번호 찾기 메일의 링크가 여는 화면(F-33): 새 비밀번호를 두 번 받아 토큰과 함께 보낸다.

export default function ResetConfirm() {
  const [params] = useSearchParams()
  const token = params.get('t') ?? ''
  const [next, setNext] = useState('')
  const [again, setAgain] = useState('')
  const [busy, setBusy] = useState(false)
  const [done, setDone] = useState(false)
  const [error, setError] = useState<unknown>(null)
  const same = next.length > 0 && next === again
  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await auth.confirmReset(token, next)
      setNext('')
      setAgain('')
      setDone(true)
    } catch (err) {
      setError(err)
    } finally {
      setBusy(false)
    }
  }
  return (
    <AuthCard title="비밀번호 재설정" onSubmit={submit}>
      {done ? (
        <>
          <p className="text-[13px]">비밀번호를 정했습니다. 로그인하세요.</p>
          <Button asChild variant="outline"><Link to="/">로그인</Link></Button>
        </>
      ) : (
        <>
          <Input type="password" placeholder="새 비밀번호" autoComplete="new-password" minLength={8} value={next} disabled={busy} onChange={(e) => setNext(e.target.value)} />
          <Input type="password" placeholder="새 비밀번호 확인" autoComplete="new-password" value={again} disabled={busy} onChange={(e) => setAgain(e.target.value)} />
          {again.length > 0 && !same ? <p className="text-[12px] text-danger-ink">비밀번호가 서로 다릅니다.</p> : null}
          <Button type="submit" disabled={busy || !token || next.length < 8 || !same} className="bg-brand hover:bg-brand-hover">
            {busy ? '저장 중' : '저장'}
          </Button>
          <Err error={error} />
          <Link to="/" className="text-center text-[12px] text-muted-foreground hover:text-foreground hover:underline">로그인</Link>
        </>
      )}
    </AuthCard>
  )
}
